import {Box, Group, Paper, Stack, Text, Title} from '@mantine/core';
import React from 'react';

type PageLayoutProps = {
    title: string;
    description?: string;
    actions?: React.ReactNode;
    children: React.ReactNode;
    /** Fill AppShell main area and let children grow (no page scroll). */
    fillViewport?: boolean;
};

export function PageLayout({
    title,
    description,
    actions,
    children,
    fillViewport = false,
}: PageLayoutProps) {
    return (
        <Paper
            p="lg"
            withBorder
            radius="md"
            style={
                fillViewport
                    ? {
                        height: 'calc(100dvh - var(--app-shell-header-offset, 56px) - 2 * var(--mantine-spacing-md))',
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                    }
                    : undefined
            }
        >
            <Stack gap="lg" style={fillViewport ? {flex: 1, minHeight: 0} : undefined}>
                <Group justify="space-between" align="flex-start" wrap="wrap">
                    <Stack gap={4}>
                        <Title order={2} fw={600} size="h3">{title}</Title>
                        {description ? (
                            <Text c="dimmed" size="sm">{description}</Text>
                        ) : null}
                    </Stack>
                    {actions}
                </Group>
                <Box
                    style={
                        fillViewport
                            ? {
                                flex: 1,
                                minHeight: 0,
                                display: 'flex',
                                flexDirection: 'column',
                            }
                            : undefined
                    }
                >
                    {children}
                </Box>
            </Stack>
        </Paper>
    );
}
